module.exports = __webpack_public_path__ + "img/cryptotimes.0c626d76.png";